import React from "react";
import TranslationContext from "./TranslationContext";

/**
 * Holds a reference to the translation context
 * @return {null}
 */
export default function useTranslationContext() {
  return React.useContext(TranslationContext);
}
